// = Libs =
import { FC, useEffect } from 'react';

// = Styles =
import classes from './page.module.scss';

// = Types =
import { PageProps } from './page.types';

// = Containers =
import Header from '@/common/containers/header/header';
import Footer from '@/common/containers/footer/footer';
import { useHistory, useLocation } from 'react-router-dom';

const Page: FC<PageProps> = (props) => {
  const { children } = props;

  const history = useHistory();
  const location = useLocation();

  const redirectTo403 = () => {
    history.push('/403');
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <>
      <Header />

      <main className={classes.page}>{children}</main>

      <Footer />
    </>
  );
};

export default Page;
